export default __webpack_public_path__ + "static/media/coppa.2c7c9aea.png";